module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-list"
  }, [_c('el-dialog', {
    attrs: {
      "title": "分组管理",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "count"
  }, [_vm._v("筛选分组总数："), _c('strong', [_vm._v(_vm._s(_vm.listData.length))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("添加分组")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("编辑分组")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listData,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "item"
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.row.id)
            }
          }
        }, [_vm._v("\n              编辑\n            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.row.id)
            }
          }
        }, [_vm._v("\n              删除\n            ")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), (_vm.editGroupShow) ? _c('edit-group', {
    attrs: {
      "formData": _vm.form,
      "id": _vm.id,
      "templateId": _vm.templateId
    },
    on: {
      "closeDialog": _vm.closeModal,
      "refresh": function($event) {
        _vm.getGroupList('refresh')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e5e08f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/customer/group-list.vue
// module id = 1213
// module chunks = 82